import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { CompensationProps } from '../../../models/arc-epi-props';
import { Employment } from '../../employment/employment-model';
import { EmploymentView } from './employer-view';

interface Props {
    employmentData: Employment;
}
export function EmploymentInfo(props: Props) {
    const { employmentData } = props;

    const epiProps = useSelector<TcsmStates, CompensationProps>(state => state?.epiProps?.compensationSettingsState?.epiContent);

    if (isEmpty(employmentData)) {
        return (
            <p>no current employment</p>
        );
    }

    return (
        <>         
            <EmploymentView
                employmentData={employmentData}
                employerLabel={epiProps?.employerLabel}
                clientNumberLabel={epiProps?.clientNumberLabel}
                hireDateLabel={epiProps?.hireDateLabel}
            />
        </>
    );
}